import {
    ActionType,
    getAssessmentScheduleAction,
    updateAssessmentScheduleAction,
    initAssessmentScheduleAction
} from "./actions";
import { RegularGoingOutJson } from "../../../../domain/assessment/RegularGoingOut";
import { RegularVisitJson } from "../../../../domain/assessment/RegularVisit";
import { createSlice } from "@reduxjs/toolkit";

export type AssessmentScheduleState = Readonly<{
    regularGoingOut: RegularGoingOutJson[],
    regularVisit: RegularVisitJson[],
    initProcess: number,
    updateProcess: number
}>;

const assessmentScheduleInitialState: AssessmentScheduleState = {
    regularGoingOut: [],
    regularVisit: [],
    initProcess: 0,
    updateProcess: 0
};
const slice = createSlice({
    name: ActionType.base,
    initialState: assessmentScheduleInitialState,
    reducers: {},
    extraReducers: (builder) => {
        builder
            .addCase(
                getAssessmentScheduleAction.pending,
                (state) => {
                    state.regularGoingOut = [];
                    state.regularVisit = [];
                    state.initProcess += 1;
                }
            )
            .addCase(
                getAssessmentScheduleAction.fulfilled,
                (state, action) => {
                    const { payload } = action;
                    const {
                        regularGoingOut,
                        regularVisit
                    } = payload;
                    state.regularGoingOut = regularGoingOut;
                    state.regularVisit = regularVisit;
                    state.initProcess -= 1;
                }
            )
            .addCase(
                getAssessmentScheduleAction.rejected,
                (state) => {
                    state.initProcess -= 1;
                }
            )
            .addCase(
                updateAssessmentScheduleAction.pending,
                (state) => {
                    state.updateProcess += 1;
                }
            )
            .addCase(
                updateAssessmentScheduleAction.fulfilled,
                (state) => {
                    state.updateProcess -= 1;
                }
            )
            .addCase(
                updateAssessmentScheduleAction.rejected,
                (state) => {
                    state.updateProcess -= 1;
                }
            )
            .addCase(
                initAssessmentScheduleAction,
                (state) => {
                    state.regularGoingOut = [];
                    state.regularVisit = [];
                    state.initProcess = 0;
                    state.updateProcess = 0;
                }
            );
    }
});

export const assessmentScheduleReducer = slice.reducer;
